<template>
  <v-dialog
    v-if="confirmMessage"
    value="true"
    scrollable
    persistent
    width="500"
    transition="dialog-transition"
  >
    <v-card>
      <v-card-title class="title warning lighten-2">
        Подтвердите действие
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text class="py-3">
        <span style="font-size: 15px" v-html="confirmMessage"></span>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="py-3">
        <v-spacer></v-spacer>
        <v-btn @click="reject()" flat>ОТМЕНА</v-btn>
        <v-btn @click="confirm()" text color="primary">ПОДТВЕРДИТЬ</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'Confirmation',
  data: () => ({}),
  computed: {
    confirmMessage () {
      return this.$store.state.confirmMessage
    }
  },
  methods: {
    confirm () {
      this.$store.dispatch('confirmConfirm')
    },
    reject () {
      this.$store.dispatch('confirmReject')
    },
  },
}
</script>

<style lang="css">
</style>
